export const NEW_LOOK_STORAGE_KEY = "new_look";

export const ignoreFailure = (action: () => void) => {
  try {
    action();
  } catch {
    return;
  }
};

export const readIsNewLook = () => {
  if (import.meta.env.DEV) {
    const param = new URLSearchParams(window.location.search).get(
      NEW_LOOK_STORAGE_KEY
    );
    if (param === "1" || param === "0") {
      ignoreFailure(() =>
        localStorage.setItem(NEW_LOOK_STORAGE_KEY, String(param === "1"))
      );
      return param === "1";
    }
  }
  try {
    return localStorage.getItem(NEW_LOOK_STORAGE_KEY) === "true";
  } catch {
    return false;
  }
};
